import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import { registerSW } from "virtual:pwa-register"

import { App } from "./App"
import "./styles/app.css"

registerSW({ immediate: true })

const root = document.getElementById("root")
if (!root) throw new Error("no #root")
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
